module.exports = __webpack_public_path__ + "static/media/bigdata.a39cae6e.png";